import type { StorageLike } from 'pinia-plugin-persistedstate';
import { persistStoreKey } from '@/modules/core/utils/persisted-store-key.util.ts';

let suppressedPersistKey: string | null = null;

function isPersistKeySuppressed(key: string): boolean {
  return key === suppressedPersistKey;
}

export function runWithSuppressedPersistKey(key: string, fn: () => void): void {
  const previous = suppressedPersistKey;
  suppressedPersistKey = key;

  try {
    fn();
  } finally {
    suppressedPersistKey = previous;
  }
}

export function hydratePersistedStore(
  store: { $id: string; $hydrate?: () => void },
  persistKey = persistStoreKey(store.$id)
): void {
  if (!store.$hydrate) {
    return;
  }

  runWithSuppressedPersistKey(persistKey, () => {
    store.$hydrate?.();
  });
}

export function createGuardedStorage(storage: StorageLike): StorageLike {
  return {
    getItem: (key) => storage.getItem(key),
    setItem: (key, value) => {
      if (isPersistKeySuppressed(key)) {
        return;
      }

      storage.setItem(key, value);
    },
  };
}
